const REDEEM_FAILED_ERROR = "redeem.bonuspoints.failed";

export class BonusPoints {
  static REDEMPTION_ERROR_MESSAGE_ID = "message.checkout.bonusPoints.redemptionError";

  async _handleRedeemBonusPointsResponse(response) {
    if (response.status === 200 || response.status === 422 || response.status === 404) {
      try {
        if (window.o_order.basket?.presenter) {
          await window.o_order.basket.presenter.reloadBasket();
        }
        if (window.o_order.checkout?.presenter) {
          await window.o_order.checkout.presenter.reloadCheckout();
        }
      } catch (e) {
        console.error(e);
        throw e;
      }

      return response;
    }
    return Promise.reject(REDEEM_FAILED_ERROR);
  }

  redeemBonusPointsAndReload(toBeRedeemed) {
    return fetch('/order/bonusPoints', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({redeemed: toBeRedeemed})
    }).then(this._handleRedeemBonusPointsResponse)
  }

  renderBonusPointRedemptionError() {
    const redemptionError = document.getElementById('or_js_bonusPoints__redemptionError');
    if (!!redemptionError) {
      redemptionError.style.display = "block";
      redemptionError.textContent = "Das hat leider nicht geklappt. Bitte versuche es erneut."
    }
  }
}
